import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@fly/core';
import { NavMenuItem, routes } from '@fly/shared';
import { FlySubMenuElementList } from '@fly/shared-ui';
import cn from 'classnames';

import styles from './AccountSideBarNav.module.less';

interface AccountSideBarNavProps {
  items: Record<string, Array<NavMenuItem>>;
}

// TODO Change button to special component
export const AccountSideBarNav: React.FC<AccountSideBarNavProps> = ({
  items,
}) => {
  const { t } = useTranslation();

  return (
    <aside className={cn(styles.accountSideBarNav, 'fadeInLeftToRight')}>
      <div className={styles.backWrapper}>
        <Button
          variant='ghost'
          color='neutral'
          to={routes.DASHBOARD.ROOT}
          iconStart='arrow_chevron_left'
        >
          {t('app.dashboard.account.back_btn', { defaultValue: 'Back' })}
        </Button>
      </div>
      <FlySubMenuElementList
        data-testid='account-submenu'
        items={items}
        displayIcon={false}
      />
    </aside>
  );
};
